export default {
  appResourceName: 'invoices',
  hasuraResourceName: 'invoiceadvance_view_invoice_advance_summary',
  fields: [
    {
      app: 'advanceAmount',
      hasura: 'advance_amount',
    },
    {
      app: 'businessProductId',
      hasura: 'business_product_id',
    },
    {
      app: 'importerName',
      hasura: 'buyer_name',
    },
    {
      app: 'creditLineId',
      hasura: 'credit_line_id',
    },
    {
      app: 'remainingBalance',
      hasura: 'balance_to_client',
    },
    {
      app: 'customerId',
      hasura: 'customer_id',
    },
    {
      app: 'dueDate',
      hasura: 'due_date',
    },
    {
      app: 'lateFees',
      hasura: 'early_late_fee',
    },
    {
      app: 'effectiveOrAdvanceAmount',
      hasura: 'effective_or_advance_amount',
    },
    {
      app: 'effectiveCollection',
      hasura: 'effective_collection',
    },
    {
      app: 'effectiveSettlement',
      hasura: 'effective_settlement',
    },
    {
      app: 'feeAtDue',
      hasura: 'fee_at_due',
    },
    {
      app: 'feeAmount',
      hasura: 'fee_to_pay',
    },
    {
      app: 'gracePeriod',
      hasura: 'gracePeriod',
    },
    {
      app: 'grossRate',
      hasura: 'grossRate',
    },
    {
      app: 'id',
      hasura: 'id',
    },
    {
      app: 'interestRatePerPeriod',
      hasura: 'interestRatePerPeriod',
    },
    {
      app: 'invoiceNumber',
      hasura: 'invoice',
    },
    {
      app: 'invoiceAmount',
      hasura: 'invoice_amount',
    },
    {
      app: 'issuedDate',
      hasura: 'issue_date',
    },
    {
      app: 'lateFeeMultiplier',
      hasura: 'lateFeeMultiplier',
    },
    {
      app: 'maxDays',
      hasura: 'maxDays',
    },
    {
      app: 'maxValue',
      hasura: 'maxValue',
    },
    {
      app: 'overdraft',
      hasura: 'overdraft',
    },
    {
      app: 'paidAt',
      hasura: 'paid_at',
    },
    {
      app: 'paymentBulkId',
      hasura: 'payment_bulk_id',
    },
    {
      app: 'receivedAmount',
      hasura: 'received_amount',
    },
    {
      app: 'requestBulkId',
      hasura: 'request_bulk_id',
    },
    {
      app: 'settledAt',
      hasura: 'settled_at',
    },
    {
      app: 'tabName',
      hasura: 'state',
    },
    {
      app: 'paymentBulkId',
      hasura: 'payment_bulk_id',
    },
    {
      app: 'requestedAt',
      hasura: 'requested_at',
    },
    {
      app: 'repaymentAmount',
      hasura: 'repayment_amount',
    },
  ],
}
